import React from 'react';

import PropTypes from 'prop-types';

import getTheAppBanner2x from 'assets/images/get-the-app-banner2x.jpg';
import getTheAppBanner3x from 'assets/images/get-the-app-banner3x.jpg';
import appleStore from 'assets/images/apple-store@3x.png';
import googleStore from 'assets/images/google-play@3x.png';

import Text from 'components/shared/ui/Text';

import siteStyle from 'utils/siteStyle';

const GetTheApp = ({ className }) => {
  const renderAppStoreButton = (title, icon, href) => {
    if (!href) return null;
    return (
      <a href={href} target="_blank" rel="noopener noreferrer">
        <img src={icon} alt={title} className="h-9 md:h-10" loading="lazy" />
      </a>
    );
  };

  return (
    <section className={className}>
      <div className="w-full max-w-300">
        <Text variant="h3">Get the app</Text>
        <p className="pt-1 font-primary-two text-4 leading-5 -tracking-0.2 text-dark md:pt-2">Golf wherever, whenever on the go.</p>
        <div className="mt-4 border border-light-grey-four rounded-2 overflow-hidden md:mt-6 md:flex md:items-center">
          <div className="flex-1 h-50 md:h-60 md:max-w-104">
            <img
              src={getTheAppBanner2x}
              srcSet={`${getTheAppBanner2x} 1024w, ${getTheAppBanner3x} 7729w`}
              sizes="(min-width: 501px) and (max-width: 767px) 1300px, 480px"
              className="w-full h-full object-cover object-center"
              alt="get the app banner"
            />
          </div>
          <div className="px-4 py-6 md:px-6 lg:px-10">
            <h2
              className={siteStyle({
                common: 'text-5 leading-6 -tracking-0.2 text-dark',
                // bt: 'font-korolav font-bold uppercase',
                default: 'font-primary font-black',
              })}
            >
              Book on the go
            </h2>
            <p className="mt-2 font-primary-two text-4 leading-5 text-grey-3 -tracking-0.2">
              Find a tee time when the moment strikes with our
              <br className="hidden md:block lg:hidden" />
              {' '}
              mobile app.
              {' '}
              <br className="hidden lg:block xl:hidden" />
              Available on iOS and Android.
            </p>
            <div className="mt-6 flex items-center gap-2 md:mt-4">
              {renderAppStoreButton('apple-store', appleStore, process.env.REACT_APP_IOS_APP_LINK)}
              {renderAppStoreButton('google-play', googleStore, process.env.REACT_APP_GOOGLE_APP_LINK)}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

GetTheApp.defaultProps = {
  className: '',
};

GetTheApp.propTypes = {
  className: PropTypes.string,
};

export default GetTheApp;
